<template>
  <b-nav-item-dropdown ref="tasks-dropdown" class="dropdown-notification mr-25" menu-class="nx-dropdown" right @show="onShow">
    <template #button-content>
      <feather-icon :badge="openCount > 0 ? openCount : ''" badge-classes="bg-primary" class="text-body" icon="CheckSquareIcon" size="21"/>
    </template>

    <li class="nx-dd__header">
      <div class="nx-dd__title">
        <span class="nx-dd__icon"><i class="fa-solid fa-list-check"></i></span>
        <span>{{ $t('menu.tasks') }}</span>
      </div>
      <b-badge pill class="nx-dd__count">{{ openCount }}</b-badge>
    </li>

    <li class="nx-dd__list">
      <b-spinner small v-if="loading" class="d-block mx-auto my-2"/>
      <template v-else>
        <b-link v-for="task in tasks" :key="task.id" class="nx-item" @click="openTask(task)">
          <div class="nx-item__avatar">
            <span class="task-dd__ic" :style="{ background: meta(task.type).color }"><i :class="meta(task.type).icon"></i></span>
          </div>
          <div class="nx-item__content">
            <div class="nx-item__title">{{ task.title }}</div>
            <div class="nx-item__body">
              <b-badge :variant="statusVariant(task.status)" class="mr-50">{{ $t('taskStatuses.' + task.status) }}</b-badge>
              <span v-if="task.dueDate" :class="{ 'text-danger': isOverdue(task) }">{{ task.dueDate | momentDate }}</span>
            </div>
          </div>
        </b-link>
        <div v-if="!tasks.length" class="nx-empty">
          <i class="fa-solid fa-mug-hot"></i>
          <span>{{ $t('tasks.allCaughtUp') }}</span>
        </div>
      </template>
    </li>

    <li class="nx-dd__footer">
      <b-button variant="flat-primary" size="sm" block @click="goToTasks">{{ $t('tasks.viewAll') }}</b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { taskMeta, STATUS_VARIANT } from '@/model/task/taskTypeMeta'

export default {
  name: 'TasksDropdown',
  data: () => ({ tasks: [], openCount: 0, loading: false }),
  computed: {
    ...mapGetters('user', ['user']),
  },
  created() {
    this.refreshCount()
  },
  methods: {
    ...mapActions('tasks', ['getAllTasks', 'getMyOpenTaskCount']),
    meta(t) { return taskMeta(t) },
    statusVariant(s) { return STATUS_VARIANT[s] || 'light' },
    isOverdue(task) { return !!task.dueDate && task.status !== 'DONE' && this.$moment(task.dueDate).isBefore(this.$moment()) },
    refreshCount() {
      this.getMyOpenTaskCount().then(c => { this.openCount = c || 0 }).catch(() => {})
    },
    onShow() {
      this.refreshCount()
      this.loading = true
      const myId = this.user ? this.user.id : null
      this.getAllTasks({
        pagination: { page: 1, size: 8 },
        sort: { field: 'dueDate', direction: 'ASC' },
        filter: { assigneeUserId: myId, statuses: ['NEW', 'IN_PROGRESS', 'ON_HOLD'] },
      }).then(
        res => { this.tasks = res.data || [] },
        () => {}
      ).finally(() => { this.loading = false })
    },
    openTask(task) {
      this.$refs['tasks-dropdown'].hide(true)
      this.$router.push({ name: 'tasks', query: { task: task.id } }).catch(() => {})
    },
    goToTasks() {
      this.$refs['tasks-dropdown'].hide(true)
      this.$router.push({ name: 'tasks' }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.task-dd__ic {
  display: inline-flex; align-items: center; justify-content: center;
  width: 36px; height: 36px; border-radius: 10px; color: #fff; font-size: 0.85rem;
}
.nx-empty {
  display: flex; flex-direction: column; align-items: center; gap: 0.4rem;
  padding: 1.4rem; color: #b8c2cc; font-size: 0.85rem;
}
.nx-empty i { font-size: 1.4rem; }
</style>
